export default __webpack_public_path__ + "static/logo-c0654d0276157529c496332bd9428c38.svg";